module.exports = __webpack_public_path__ + "img/img19.71330270.svg";